import { Field, Model } from 'serialize-ts';

@Model()
export class DestinationRegion {
  @Field()
  value: string;
}

@Model()
export class Cost {
  @Field()
  currency: string;
  @Field()
  vatRate: string;
  @Field()
  net: string;
  @Field()
  gross: string;
}

@Model()
export class ShippingCost {
  @Field()
  destinationRegion: DestinationRegion;

  @Field()
  unitCost: Cost;

  @Field()
  extraUnitCost: Cost;

  @Field()
  thresholdEnabled: boolean;

  @Field()
  thresholdAmount: Cost;
}

@Model()
export class ShippingGroup {
  @Field()
  id: string;

  @Field()
  name: string;

  @Field()
  shippingCost: ShippingCost;
}

